<script setup lang="ts"></script>

<template>
  <NuxtErrorBoundary>
    <section class="flex h-dvh items-center justify-center px-6">
      <div
        class="flex w-full max-w-md flex-col gap-2 rounded-lg border border-gray-300 p-6 shadow-lg"
      >
        <img
          src="~/assets/images/reset-password.png"
          alt=""
          class="max-w-32 self-center"
        />
        <slot />
      </div>
    </section>

    <template #error="{ error }">
      <Error :error="error" />
    </template>
  </NuxtErrorBoundary>
</template>

<style></style>
